import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/components/common/messageservice';
import { ConfirmationService } from 'primeng/primeng';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { WebPage } from '../../shared/web-page';
import { CandidatoService } from '../candidato.service';

@Component({
  selector: 'sispac-arquivos-gerais-candidato',
  templateUrl: './arquivos-gerais-candidato.component.html',
  styleUrls: ['./arquivos-gerais-candidato.component.css']
})
export class ArquivosGeraisCandidatoComponent extends WebPage  implements OnInit {

  idCandidato;
  listaArquivosGerais;
  candidato;

  constructor(
    private candidatoService: CandidatoService,
    messageService: MessageService,
    private arquivoService: ArquivoService,
    private route: ActivatedRoute,
    private router: Router,
    private confirmationService: ConfirmationService
  )
  {

      super(messageService);
      //PEGA ID CANDIDATO DA URL
      this.route.paramMap.subscribe(params =>
        this.idCandidato = params.get('idCandidato')
      );

    }

  ngOnInit() {
    this.buscarCandidato();
    this.getArquivosGerais();
  }

  downloadArquivo(idArquivo, nomeArquivo) {
    this.arquivoService.downloadArquivo(idArquivo, nomeArquivo);
  }

  remover(idCandidatoArquivoGeral){
    this.confirmationService.confirm({
      message: 'Deseja realmente excluir este arquivo? Ele será excluído permanentemente',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
          this.candidatoService.removerArquivoGeral(idCandidatoArquivoGeral)
          .subscribe(candidato => {
            this.messageService.add({
              severity: 'success',
              summary: 'Atenção',
              detail: 'Arquivo excluido com sucesso'
            });

            this.getArquivosGerais();

          });
        }
      });
    }



  getArquivosGerais(){
    this.candidatoService.getArquivosGerais(this.idCandidato)
      .subscribe(
        data => {
          this.listaArquivosGerais = data;
        },
        error => this.gerenciaErro(error)
      );
  }

  buscarCandidato(){
    this.candidatoService.getFull(this.idCandidato)
      .finally(() => this.isLoading = false)
      .subscribe(
        candidato => {
          this.candidato = candidato;
        },
        error => this.gerenciaErro(error)
      );
  }

  inserirArquivo(idCandidato)  {
    this.router.navigate(['/inserir-arquivo-geral',  this.idCandidato]);
  }



}



// WEBPACK FOOTER //
// ./src/app/components/candidato/arquivos-gerais-candidato/arquivos-gerais-candidato.component.ts